import { Box, Grid, ThemeProvider } from '@mui/material';
import { useGetTransactionsService } from '../../../../services';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderTable } from '../../../components/core/HeaderTable';
import { DataGrid, GridColDef, GridFilterModel, GridRowId, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { GridActionsCellItem } from '@mui/x-data-grid';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { buttonStyles } from '../../../../theme/styles';
import { themeDataGrid, themeSearch } from '../../../../theme/colors';
import moment from 'moment';
import { statusTransaction, typeTransaction } from '../../../commons/hooks';
import { GridSortModel } from '@mui/x-data-grid';

function CustomToolbar() {
  const classes = buttonStyles();
  return (
    <GridToolbarContainer>
      <Grid item xs={12} display={'flex'} justifyContent={'space-between'} alignItems={'center'} pt={0.5} pl={1} pr={1} mb={4}>
        <GridToolbarExport className={classes.button} />
        <ThemeProvider theme={themeSearch}>
          <GridToolbarQuickFilter />
        </ThemeProvider>
      </Grid>
    </GridToolbarContainer>
  );
}


export const Transactions = () => {
  const navigate = useNavigate();
  const { data, working: loading, callCustomers: callTransaction } = useGetTransactionsService({}, { autoCall: false });
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

  const transactions = data?.transactions.map((item) => ({
    transaction_id: item.transactionId,
    email: item.customer.email,
    company: item.company.name,
    transaction_type: typeTransaction(item),
    status: statusTransaction(item),
    created_at: moment(item.createdAt).format('D-MM-YYYY, HH:mm:ss'),
    customer_id: item.customer.customerId
  }));

  const columnsTransaction: GridColDef[] = [
    { field: 'transaction_id', headerName: 'ID', flex: 1, editable: false, disableColumnMenu: true, sortable: false },
    { field: 'email', headerName: 'Email', flex: 1, editable: false, disableColumnMenu: true },
    { field: 'company', headerName: 'Compañía', flex: 1, editable: false, disableColumnMenu: true },
    { field: 'transaction_type', headerName: 'Tipo de Transaccion', flex: 1, editable: false, disableColumnMenu: true },
    { field: 'status', headerName: 'Estado', flex: 1, editable: false, disableColumnMenu: true },
    { field: 'created_at', headerName: 'Creada', flex: 1, editable: false, disableColumnMenu: true },
    {
      field: 'operations',
      headerName: 'Operaciones',
      type: 'actions',
      editable: false,
      flex: 1,
      cellClassName: 'actions',
      getActions: ({id}) => {
        return [
          <GridActionsCellItem icon={<VisibilityOutlinedIcon />} label="Details" className="textPrimary" onClick={handleDatailsClick(id)} color="inherit" />,
        ];
      },
    },
  ];

  const handleDatailsClick = (id: GridRowId) => () => {
    navigate(`/transactions/${id}`);
  };

  const onFilterChange = useCallback((filterModel: GridFilterModel) => {
    if (filterModel.items[0].value) {
      //aca le tenes que pasar el filtro.
      callTransaction({ limit: paginationModel.pageSize, offset: (paginationModel.page * paginationModel.pageSize), orderBy: '' });
    }
  }, []);

  // const handleSortModelChange = useCallback((sortModel: GridSortModel) => {
  //   // Here you save the data you need from the sort model
  //   console.log(sortModel)
  //   setSort({ sortModel: [...sortModel] });
  // }, []);

  useEffect(() => {
    callTransaction({ limit: paginationModel.pageSize, offset: (paginationModel.page * paginationModel.pageSize), orderBy: '' });
  }, [paginationModel]);

  return (
    <Fragment>
      <Box width="100%" height="100%" paddingX={4}>
        <Grid container rowSpacing={4} spacing={4}>
          <Grid item xs={8}>
            <HeaderTable title="Transacciones" />
          </Grid>
          <Grid item pb={4} sx={{ height: 700, width: '100%', '& .actions': { color: 'text.secondary' }, '& .textPrimary': { color: 'text.primary' } }}>
            <ThemeProvider theme={themeDataGrid}>
              <DataGrid
                localeText={{ toolbarExportCSV: 'Exportar a CSV', toolbarExportPrint: 'Imprimir', toolbarExport: 'Exportar' }}
                getRowId={(id) => id?.transaction_id}
                columns={columnsTransaction}
                rows={transactions || []}
                filterMode="server"
                onFilterModelChange={onFilterChange}
                loading={loading}
                rowCount={+(data?.transaction_count || 0)}
                paginationMode="server"
                pageSizeOptions={[10, 25, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                slots={{ toolbar: CustomToolbar }}
                initialState={{
                  ...data?.transactions,
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterValues: [''],
                    },
                  },
                }}
              />
            </ThemeProvider>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
};
